import MyFlow from "flow/MyFlow";
import config from "flow/config";
import baseUrl from "flow/wrappers/baseUrl";
import ko from "knockout";

let stubCounter = 0;

function createMyFlow(manifest: any, options?: any) {
    if (!options) {
        options = {};
    }

    if (!options.component) {
        const cuid = manifest.id === config.flowId ? config.flowId : `stub_${++stubCounter}`;
        options.component = {
            cuid: cuid,
            x: 0,
            y: 0,
            order: 0,
            minimizedWidth: 0,
            minimizedHeight: 0,

            isBroken: ko.observable<boolean>(false),
            isLoading: ko.observable<boolean>(false),
            viewHtml: ko.observable<string>(),
            detailHtml: ko.observable<string>(),
            notificationsHtml: ko.observable<string>(),
            viewModel: ko.observable<any>(),

            isMaximized: ko.observable<boolean>(false),
            adjustedWidth: ko.observable<boolean>(false),
            adjustedHeight: ko.observable<boolean>(false),
            isVisible: ko.observable<boolean>(true),
            isSelected: ko.observable<boolean>(false),

            isShadow: ko.observable<boolean>(false),
            element: ko.observable<JQuery<HTMLElement>>(),
            contentElement: null as HTMLElement,
            inspectionEnabled: ko.observable<boolean>(false),
            notificationText: ko.observable<string>(undefined),
            notificationType: ko.observable<number>(),
            notificationOpaque: ko.observable<boolean>(false),
            notificationSticky: ko.observable<boolean>(false),
            originalTitle: ko.observable<string>(),
            publishOnTitleChange: false,

            footerText: ko.observable<string>(),
            inEdit: ko.observable<boolean>(false),
            isDirty: ko.observable<boolean>(false),
            expanderWantsVisibility: ko.observable<boolean>(false),
            canRemember: ko.observable<boolean>(false),
            alreadyLoading: false,

            title: ko.observable<string>(),
            bottomNavigationTitle: ko.observable<string>(),

            activate() {},
            onShow() {},
            onHide() {},
            onDestroy() {},
            canLeave() {
                return true;
            },
            hasForm() {
                return false;
            },
            onViewAttached() {},
            onDetailViewAttached() {},
            onNotificationsViewAttached() {},
            shouldBeVisible() {
                return false;
            },
            hint() {
                return undefined as any;
            },
            onSelected() {},
            onFocus() {},
            onContainerSizeChanged() {},
            getDimensions() {
                return {
                    width: "auto",
                    height: "auto"
                };
            },
            toolbarButtonGroupAfterRender() {},
            onBeforeNavigateBack() {},
            useValidationV3() {
                return false;
            }
        };
    }

    return new MyFlow(manifest, options);
}

function createTestFlow(manifest: any, options?: any) {
    if (!manifest) {
        manifest = {
            id: config.flowId,
            baseUrl: baseUrl,
            moduleId: config.moduleId,
            moduleKeyName: config.moduleKeyName
        };
    }

    const testFlow = createMyFlow(manifest, options);

    return testFlow;
}

export default {
    createMyFlow: createMyFlow,
    createTestFlow: createTestFlow
};
